export default "__VITE_ASSET__9dd15832__"